import React, { useState } from 'react';

function EmailForm({ onSubmit }) {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(email);
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Podaj swój email"
        required
      />
      <button type="submit">Rozpocznij quiz</button>
    </form>
  );
}

export default EmailForm;